export const EVENTS = {
	KSYS_APP_LOADED: 'ksys-app-loaded',
	KSYS_APPS_LOADED: 'ksys-apps-loaded',
	KSYS_APP_EMBED_ADDED: 'ksys-app-embed-added',
};